/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ControlRouteImport } from './routes/control'
import { Route as DisplayOutputIdRouteImport } from './routes/display.$outputId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ControlRoute = ControlRouteImport.update({
  id: '/control',
  path: '/control',
  getParentRoute: () => rootRouteImport,
} as any)
const DisplayOutputIdRoute = DisplayOutputIdRouteImport.update({
  id: '/display/$outputId',
  path: '/display/$outputId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/control': typeof ControlRoute
  '/display/$outputId': typeof DisplayOutputIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/control': typeof ControlRoute
  '/display/$outputId': typeof DisplayOutputIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/control': typeof ControlRoute
  '/display/$outputId': typeof DisplayOutputIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/control' | '/display/$outputId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/control' | '/display/$outputId'
  id: '__root__' | '/' | '/control' | '/display/$outputId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ControlRoute: typeof ControlRoute
  DisplayOutputIdRoute: typeof DisplayOutputIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/control': {
      id: '/control'
      path: '/control'
      fullPath: '/control'
      preLoaderRoute: typeof ControlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/display/$outputId': {
      id: '/display/$outputId'
      path: '/display/$outputId'
      fullPath: '/display/$outputId'
      preLoaderRoute: typeof DisplayOutputIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ControlRoute: ControlRoute,
  DisplayOutputIdRoute: DisplayOutputIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
